import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InvoicePage from "../invoices/invoice";
import ExtraInvoice from "../invoices/extra_invs";
import axios from "axios";
import GRCPrint from "../invoices/grc_print";

const CheckoutPage = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [bookingDetails, setBookingDetails] = useState([]);

  const guests = {
    id: JSON.parse(location.state.guest_ids).id,
    name: JSON.parse(location.state.guest_ids).name,
  };

  const [foodBill, setFoodBill] = useState(false);
  const [extraCharge, setExtraCharge] = useState(false);
  const [addRemarks, setAddRemarks] = useState(false);
  const [showInvoice, setShowInvoice] = useState(false);

  const [foodBillE, setFoodBillE] = useState(false);
  const [extraChargeE, setExtraChargeE] = useState(false);
  const [addRemarksE, setAddRemarksE] = useState(false);
  const [showInvoiceE, setShowInvoiceE] = useState(false);
  const [showGrc, setShowGrc] = useState(false);
const [multiPayments, setMultiPayments] = useState([
  { method: "", amount: "" },
]);
const [showMultiPayUI, setShowMultiPayUI] = useState(false);


      const hotelDetail = props.clientDetails;


  function invoiceToggler() {
    setShowInvoiceE(false);
    setAddRemarksE(false);
    setExtraChargeE(false);
    setFoodBillE(false);
  }

  const getCurrentDateTime = (now) => {
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };

  const [formData, setFormData] = useState({
    booking_id: location.state.booking_id,
    guest_data: location.state.guest_ids,
    room_id: location.state.room_id,
    room_no: location.state.room_no,
    from_date: location.state.from_date || "",
    to_date:
      location.state.to_date === "0000-00-00 00:00:00"
        ? getCurrentDateTime(new Date())
        : location.state.to_date,
    no_of_stayers: location.state.no_of_stayers || 1,
    total_amount: location.state.total_amount || 0,
    discount: "0",
    advance_amount: location.state.advance_amount || 0,
    food_price: location.state.food_order_total,
    remarks: location.state.remarks || "",
    inv_no: location.state.inv_no || null,
    food_tax_rate: 5,
    food_tax_amount: 0,
    extra_charges: 0,
    payment_method: "",
    rest_amount: 0,
    tax_rate: 5,
    tax_amount: 0,
    from_location: location.state.from_location || 'NA',
    to_location: location.state.to_location || 'NA',
  });

  const calculateDaysDifference = (from, to) => {
    if (!from || !to) return 0;
    const fromDate = new Date(from);
    const toDate = new Date(to);
    const timeDifference = toDate - fromDate;
    return Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
  };


  const handleMultiPaymentChange = (index, key, value) => {
  const updated = [...multiPayments];
  updated[index][key] = value;
  setMultiPayments(updated);
};

const handleAddPaymentMethod = () => {
  setMultiPayments([...multiPayments, { method: "", amount: "" }]);
};

const finalizeMultiplePayment = () => {
  const methodString = multiPayments
    .filter((entry) => entry.method && entry.amount)
    .map((entry) => `${entry.method}-${entry.amount}`)
    .join(" | ");

  if (methodString) {
    setFormData((prev) => ({
      ...prev,
      payment_method: `Multiple Method | ${methodString}`,
    }));
  }

  setShowMultiPayUI(false);
};


  // Handle form changes
  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prev) => {
  //     const updatedFormData = { ...prev, [name]: value };

  //     // Calculate total amount when dates are updated
  //     if (name === "to_date") {
  //       const days = calculateDaysDifference(
  //         updatedFormData.from_date,
  //         updatedFormData.to_date
  //       );
  //       const previousDays = calculateDaysDifference(
  //         updatedFormData.from_date,
  //         location.state.to_date === "0000-00-00 00:00:00"
  //           ? getCurrentDateTime(new Date())
  //           : location.state.to_date
  //       );
  //       const total = days * (location.state.total_amount / previousDays);
  //       updatedFormData.total_amount = days > 0 ? total.toFixed(2) : "";
  //     }

  //     return updatedFormData;
  //   });
  // };
const extractTime = (dateTime) => {
  if (!dateTime) return null;

  // Matches HH:MM or HH:MM:SS
  const timeMatch = dateTime.match(/(\d{1,2}):(\d{2})(?::\d{2})?/);
  if (!timeMatch) return null;

  const hours = timeMatch[1].padStart(2, "0");
  const minutes = timeMatch[2];

  return `${hours}:${minutes}`;
};


const timeToMinutes = (timeStr) => {
  if (!timeStr) return 0;
  const [h, m] = timeStr.split(":").map(Number);
  return h * 60 + m;
};

const isCheckoutLate = (checkoutDateTime, allowedTime) => {
  const checkoutTime = extractTime(checkoutDateTime);
  if (!checkoutTime || !allowedTime) return false;

  const checkoutMinutes = timeToMinutes(checkoutTime);
  const allowedMinutes = timeToMinutes(allowedTime);

  return checkoutMinutes >= allowedMinutes;
};


    const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => {
      const updatedFormData = { ...prev, [name]: value };

      // Calculate total amount when dates are updated
if (name === "to_date") {
  // Step 1: Calculate days between from_date and to_date
  let days = calculateDaysDifference(
    updatedFormData.from_date,
    updatedFormData.to_date
  );

const allowedCheckoutTime = props?.clientDetails?.checko_time;

if (
  allowedCheckoutTime &&
  allowedCheckoutTime !== "00:00:00" &&
  updatedFormData?.to_date &&
  isCheckoutLate(updatedFormData.to_date, allowedCheckoutTime)
) {
  days += 1;
}

  // Step 3: Calculate per day amount using original total / original booked days
  const originalDays = calculateDaysDifference(
    updatedFormData.from_date,
    location.state.to_date === "0000-00-00 00:00:00"
      ? getCurrentDateTime(new Date())
      : location.state.to_date
  );

  const perDayAmount =
    originalDays > 0 ? location.state.total_amount / originalDays : 0;

  const total = days * perDayAmount;

  updatedFormData.total_amount = days > 0 ? total.toFixed(2) : "";
}

      return updatedFormData;
    });
  };

  const handleNumberChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: parseFloat(value) || 0,
    }));
  };

  const calculateGSTAmount = (totalAmount, gstRate) => {
    return (totalAmount * gstRate) / 100;
  };

  const sumByKey = (arr, key) => {
    return arr
      .reduce((total, item) => {
        return total + (parseFloat(item[key]) || 0);
      }, 0)
      .toFixed(2);
  };

  // Fetch booking details if multiple bookings
  useEffect(() => {
    if (location.state.group_id && bookingDetails.length < 1) {
      axios
        .get(
          `https://api.dectwinhotel.com/api/${props.id}_bookings/multi-book/${location.state.group_id}`
        )
        .then((response) => {
          if (response.data.length > 0) {
            setBookingDetails(response.data);
            setFormData({
              ...formData,
              total_amount: sumByKey(response.data, "total_amount"),
              advance_amount: sumByKey(response.data, "advance_amount"),
            });
          }
        })
        .catch((e) => {});
    }
  }, [props.id, location.state.group_id, formData, bookingDetails.length]);

  const handleSubmitCheckout = async (e) => {
    e.preventDefault();
    props.handleLoading();
    if (bookingDetails.length > 1) {
      const updatedBookings = bookingDetails.map((booking) => {
        const taxAmount = calculateGSTAmount(
          formData.total_amount - formData.discount,
          formData.tax_rate
        );
        const lastAmount =
          parseFloat(booking.total_amount) - parseFloat(booking.advance_amount);

        formData.food_tax_amount = calculateGSTAmount(
          formData.food_price,
          formData.food_tax_rate
        );

        formData.tax_amount = calculateGSTAmount(
          formData.total_amount - formData.discount,
          formData.tax_rate
        );

        return {
          ...booking,
          tax_rate: formData.tax_rate,
          tax_amount: taxAmount.toFixed(2),
          rest_amount: lastAmount.toFixed(2),
          payment_method: formData.payment_method,
          remarks: formData.remarks,
          discount: formData.discount,
          food_tax_rate: formData.food_tax_rate,
          food_tax_amount: formData.food_tax_amount,
          out_staff_name: null,
          to_date: formData.to_date,
          extra_charges: formData.extra_charges,
          food_price: formData.food_price,
          from_location: formData.from_location,
          to_location: formData.to_location,
        };
      });
      await axios
        .put(
          `https://api.dectwinhotel.com/api/${props.id}_bookings/multi-checkout`,
          updatedBookings
        )
        .then((response) => {
          props.handleToast({
            toastMsg: "Check Out Successfully!!!",
            toastColor: "#4CAF50",
          });
          setShowInvoice(true);
          props.toggleHeader();
          props.closeLoading();
        })
        .catch((error) => {
          props.closeLoading();
        });
    } else {
      formData.tax_amount = calculateGSTAmount(
        formData.total_amount - formData.discount,
        formData.tax_rate
      );
      formData.food_tax_amount = calculateGSTAmount(
        formData.food_price,
        formData.food_tax_rate
      );
      formData.rest_amount =
        formData.total_amount -
        formData.advance_amount +
        formData.extra_charges +
        formData.tax_amount;
      formData.checkout_time = getCurrentDateTime(new Date());

      await axios
        .put(
          `https://api.dectwinhotel.com/api/${props.id}_bookings/checkout/${location.state.booking_id}`,
          formData
        )
        .then((response) => {
          props.handleToast({
            toastMsg: "Check Out Successfully!!!",
            toastColor: "#4CAF50",
          });
          setShowInvoice(true);
          props.toggleHeader();
          props.closeLoading();
        })
        .catch((error) => {
          props.closeLoading();
        });
    }
  };

  return (
    <section style={{ padding: "1rem" }}>
      {!showInvoice && !showInvoiceE && !showGrc && (
        <div className="book-room-form">
          <h2>
            Checkout Room No{" "}
            {bookingDetails.length > 1
              ? bookingDetails.map((b) => b.room_no).join(", ")
              : location.state.room_no}
          </h2>
          <form onSubmit={handleSubmitCheckout}>
            {guests.id.length > 0 &&
              guests.id.map((ids, index) => (
                <div key={ids} className="guest-entry">
                  <label htmlFor="guest_name">Guest {index + 1} Name</label>
                  <input
                    type="text"
                    name="guest_name"
                    value={guests.name[index]}
                    readOnly
                    required
                  />
                </div>
              ))}

            <label htmlFor="from_date">From Date</label>
            <input
              type="datetime-local"
              name="from_date"
              value={formData.from_date}
              readOnly
              required
            />

            <label htmlFor="to_date">To Date</label>
            <input
              type="datetime-local"
              name="to_date"
              min={formData.from_date}
              value={formData.to_date}
              onChange={handleChange}
            />

            <label htmlFor="from_location">From Location</label>
            <input
              type="text"
              name="from_location"
              value={formData.from_location}
              onChange={handleChange}
              required
            />

            <label htmlFor="to_location">To Location</label>
            <input
              type="text"
              name="to_location"
              value={formData.to_location}
              onChange={handleChange}
              required
            />

            {bookingDetails.length > 1 ? (
              bookingDetails.map((bookg) => (
                <div key={bookg.booking_id}>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "37.5% 22% 37%",
                      gap: "10px",
                    }}
                  >
                    <div>
                      <label>Room No. {bookg.room_no}</label>
                      <input
                        type="text"
                        name="room_no"
                        placeholder="Room Number"
                        maxLength={7}
                        value={`Room No - ${bookg.room_no || ""}`}
                        disabled
                      />
                    </div>
                    <div>
                      <label>No of Adult(s)</label>
                      <input
                        type="text"
                        name="no_of_stay"
                        placeholder="No of Adult(s)"
                        maxLength={7}
                        value={bookg.no_of_stayers || ""}
                        disabled
                      />
                    </div>
                    <div>
                      <label>Room Rent</label>
                      <input
                        type="text"
                        name="room_rent"
                        placeholder="Room Rent"
                        maxLength={7}
                        value={bookg.total_amount || ""}
                        disabled
                      />
                    </div>
                  </div>
                  {bookg.checkout_status !== 1 && (
                    <button
                      type="button"
                      onDoubleClick={async () => {
                        console.log(bookg);

                        props.handleLoading();
                        const taxAmount = calculateGSTAmount(
                          formData.total_amount - formData.discount,
                          formData.tax_rate
                        );
                        const lastAmount =
                          parseFloat(bookg.total_amount) -
                          parseFloat(bookg.advance_amount);

                        const singleOut = {
                          ...bookg,
                          tax_rate: formData.tax_rate,
                          tax_amount: taxAmount.toFixed(2),
                          rest_amount: lastAmount.toFixed(2),
                          payment_method: "Cash",
                          remarks: bookg.remarks,
                          food_tax_rate: bookg.food_tax_rate,
                          food_tax_amount: bookg.food_tax_amount,
                          out_staff_name: null,
                          checkout_status: 1,
                          to_date: bookg.to_date,
                          extra_charges: bookg.extra_charges,
                          food_price: bookg.food_order_total,
                          checkout_time: getCurrentDateTime(new Date()),
                        };
                        console.log(singleOut);
                        await axios
                          .put(
                            `https://api.dectwinhotel.com/api/${props.id}_bookings/checkout/${singleOut.booking_id}`,
                            singleOut
                          )
                          .then((response) => {
                            props.handleToast({
                              toastMsg: "Check Out Successfully!!!",
                              toastColor: "#4CAF50",
                            });
                            localStorage.removeItem("rooms");
                            localStorage.removeItem(
                              `food_order_${singleOut.booking_id}`
                            );
                            props.closeLoading();
                            navigate("/admin/rooms", { replace: true });
                          })
                          .catch((error) => {
                            props.closeLoading();
                          });
                      }}
                    >
                      Checkout from Room No: {bookg.room_no}
                    </button>
                  )}
                </div>
              ))
            ) : (
              <>
                <label htmlFor="no_of_stayers">Number of Adult(s)</label>
                <select
                  name="no_of_stayers"
                  value={formData.no_of_stayers}
                  readOnly
                  disabled
                  required
                >
                  <option value="">{formData.no_of_stayers}</option>
                </select>
              </>
            )}

            <label htmlFor="total_amount">Total Amount</label>
            <input
              type="text"
              name="total_amount"
              value={formData.total_amount}
              readOnly
              required
            />

            <label htmlFor="total_amount">Discount</label>
            <input
              type="text"
              name="discount"
              value={formData.discount}
              onChange={handleNumberChange}
              required
            />

            <label htmlFor="advance_amount">Advance Amount</label>
            <input
              type="text"
              name="advance_amount"
              value={formData.advance_amount}
              readOnly
              required
            />

            <label htmlFor="payment_method">Payment Method</label>
            {/* <select
              name="payment_method"
              value={formData.payment_method}
              onChange={handleChange}
              required
            >
              <option value="">Select Payment Method</option>
              <option value="Cash">Cash</option>
              <option value="Unified Payment Interface (UPI)">
                Unified Payment Interface (UPI)
              </option>
              <option value="Credit Card">Credit Card</option>
              <option value="Debit Card">Debit Card</option>
              <option value="Credit(Due)">Credit(Due)</option>
              <option value="Multiple Method">Multiple Method</option>
            </select> */}
<select
  name="payment_method"
  value={
    formData.payment_method.startsWith("Multiple Method")
      ? "Multiple Method"
      : formData.payment_method
  }
  onClick={(e) => {
    const value = e.target.value;
    if (value === "Multiple Method") {
     const entries = formData.payment_method
  .replace("Multiple Method | ", "")
  .split(" | ")
  .map((item) => {
    const [method, amount] = item.split("-");
    return { method: method || "", amount: amount || "" };
  });

      setMultiPayments(entries);
      setShowMultiPayUI(true);
    }
  }}
  onChange={(e) => {
    const value = e.target.value;

    if (value === "Multiple Method") {
      const entries = formData.payment_method.startsWith("Multiple Method | ")
        ? formData.payment_method
            .replace("Multiple Method | ", "")
            .split(" | ")
            .map((item) => {
              const [method, amount] = item.split("-");
              return { method, amount };
            })
        : [{ method: "", amount: "" }];

      setMultiPayments(entries);
      setShowMultiPayUI(true);
    } else {
      setFormData({ ...formData, payment_method: value });
      setShowMultiPayUI(false);
    }
  }}
  required
>
  <option value="">Select Payment Method</option>
  <option value="Cash">Cash</option>
  <option value="Unified Payment Interface (UPI)">Unified Payment Interface (UPI)</option>
  <option value="Credit Card">Credit Card</option>
  <option value="Debit Card">Debit Card</option>
  <option value="Credit(Due)">Credit(Due)</option>
  <option value="Multiple Method">Multiple Method</option>
</select>


{showMultiPayUI && (
  <div style={{ marginTop: "10px" }}>
    <h5>Select Multiple Payment Modes</h5>
    {multiPayments.map((entry, index) => (
      <div key={index} style={{ display: "flex", gap: "10px", marginBottom: "10px" }}>
        <select
          value={entry.method}
          onChange={(e) => handleMultiPaymentChange(index, "method", e.target.value)}
        >
          <option value="">Select Mode</option>
          <option value="Cash">Cash</option>
          <option value="UPI">Unified Payment Interface (UPI)</option>
          <option value="Credit Card">Credit Card</option>
          <option value="Debit Card">Debit Card</option>
          <option value="Credit(Due)">Credit(Due)</option>
        </select>
        <input
          type="number"
          placeholder="Amount"
          value={entry.amount}
          onChange={(e) => handleMultiPaymentChange(index, "amount", e.target.value)}
        />
      </div>
    ))}
    <button type="button" onClick={handleAddPaymentMethod}>
      + Add More
    </button>
    <br />
    <button type="button" onClick={finalizeMultiplePayment}>
      ✔ Done
    </button>
  </div>
)}



            <label htmlFor="remarks">Remarks</label>
            <textarea
              name="remarks"
              placeholder="Add any remarks here"
              value={formData.remarks}
              onChange={handleChange}
            />

            <label htmlFor="food_price">Food Order Amount</label>
            <input
              type="text"
              name="food_price"
              value={formData.food_price}
              onChange={handleNumberChange}
              required
            />

            <label htmlFor="food_price">GST Rate & Amount on Food Order</label>
            <div className="d-flex">
              <select
                name="food_tax_rate"
                value={formData.food_tax_rate}
                onChange={handleChange}
                required
              >
                <option value="0">GST@ 0%</option>
                <option value="3">GST@ 3%</option>
                <option value="5">GST@ 5%</option>
                <option value="12">GST@ 12%</option>
                <option value="18">GST@ 18%</option>
                <option value="28">GST@ 28%</option>
              </select>
              <input
                type="text"
                name="food_tax_amount"
                value={calculateGSTAmount(
                  formData.food_price,
                  formData.food_tax_rate
                )}
                readOnly
                required
              />
            </div>

            <label htmlFor="extra_charges">Extra Charges</label>
            <input
              type="text"
              name="extra_charges"
              value={formData.extra_charges}
              onChange={handleNumberChange}
              required
            />

            <label htmlFor="tax_rate">Tax Rate & Amount on Room</label>
            <div className="d-flex">
              <select
                name="tax_rate"
                value={formData.tax_rate}
                onChange={handleChange}
                required
              >
                <option value="0">GST@ 0%</option>
                <option value="3">GST@ 3%</option>
                <option value="5">GST@ 5%</option>
                <option value="12">GST@ 12%</option>
                <option value="18">GST@ 18%</option>
                <option value="28">GST@ 28%</option>
              </select>
              <input
                type="text"
                name="tax_amount"
                value={calculateGSTAmount(
                  formData.total_amount - formData.discount,
                  formData.tax_rate
                ).toFixed(2)}
                readOnly
                required
              />
            </div>
            <label htmlFor="rest_amount">Remaining Amount to Pay</label>
            <input
              type="text"
              name="rest_amount"
              value={(
                formData.total_amount -
                formData.discount -
                formData.advance_amount +
                formData.extra_charges +
                calculateGSTAmount(
                  formData.total_amount - formData.discount,
                  formData.tax_rate
                )
              ).toFixed(2)}
              readOnly
              required
            />

                                        <button                   onClick={() => {
          setShowGrc(true);
                    props.toggleHeader();
                  }}
                  style={{ backgroundColor: "#007bff" }} className="me-2" type="button">GRC Print</button>

            {/* Checkboxes for extra options */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "33.33% 33.33% 33.34%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  type="checkbox"
                  checked={foodBill}
                  style={{ height: "20px", width: "20px" }}
                  onChange={() => setFoodBill(!foodBill)}
                />
                <label>Print Food Bill</label>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  type="checkbox"
                  checked={extraCharge}
                  style={{ height: "20px", width: "20px" }}
                  onChange={() => setExtraCharge(!extraCharge)}
                />
                <label>Print Extra Charges</label>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <input
                  type="checkbox"
                  checked={addRemarks}
                  style={{ height: "20px", width: "20px" }}
                  onChange={() => setAddRemarks(!addRemarks)}
                />
                <label>Print Remarks</label>
              </div>
            </div>

            <br />
            <div className="d-flex">
                            <button                   onClick={() => {
          setShowInvoice(true);
                    props.toggleHeader();
                  }}
                  className="me-2" type="button">Print Copy</button>
            <button type="submit">Checkout Room</button>
            </div>
            <br />

            {bookingDetails.length < 1 && (
              <>
                <strong>Select Services to Print in Invoice</strong>

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "33.33% 33.33% 33.34%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={foodBillE}
                      style={{ height: "20px", width: "20px" }}
                      onChange={() => setFoodBillE(!foodBillE)}
                    />
                    <label>Print Food Bill</label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={extraChargeE}
                      style={{ height: "20px", width: "20px" }}
                      onChange={() => setExtraChargeE(!extraChargeE)}
                    />
                    <label>Print Extra Charges</label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={addRemarksE}
                      style={{ height: "20px", width: "20px" }}
                      onChange={() => setAddRemarksE(!addRemarksE)}
                    />
                    <label>Print Remarks</label>
                  </div>
                </div>

                <br />


                <button
                  onClick={() => {
                    setShowInvoiceE(true);
                    props.toggleHeader();
                  }}
                  style={{ backgroundColor: "#007bff" }}
                  type="button"
                >
                  Print Service Invoice
                </button>
              </>
            )}
          </form>
        </div>
      )}

      {/* InvoicePage component with conditional props */}
      {showInvoice && (
        <InvoicePage
          invoiceDetails={formData}
          printFood={foodBill}
          printExtra={extraCharge}
          printRemarks={addRemarks}
          isReprint={false}
          clientDetails={props.clientDetails}
          toggleHeader={props.toggleHeader}
          multiBills={bookingDetails}
                    // setShowInvoice={setShowInvoice}
        />
      )}

      {/* InvoicePage component with conditional props */}
      {showInvoiceE && (
        <ExtraInvoice
          invoiceToggler={invoiceToggler}
          invoiceDetails={formData}
          printFood={foodBillE}
          printExtra={extraChargeE}
          printRemarks={addRemarksE}
          clientDetails={props.clientDetails}
          toggleHeader={props.toggleHeader}
          setShowInvoiceE={setShowInvoiceE}
        />
      )}


      {showGrc && (
        <GRCPrint
          invoiceDetails={formData}
          printFood={foodBill}
          printExtra={extraCharge}
          printRemarks={addRemarks}
          isReprint={false}
          clientDetails={props.clientDetails}
          toggleHeader={props.toggleHeader}
          multiBills={bookingDetails}
          setShowGrc={setShowGrc}
        />
      )}


    </section>
  );
};

export default CheckoutPage;
